import { useEffect, useState } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { postRequest } from '~services';
import {
  VenueFilterListingResponse,
  VenueFilterOption,
  VenuesRequestParams,
} from '~types';
import { getNextPage } from '~utils/pagination.util';

export const useQueryInfiniteVenues = () => {
  const [items, setItems] = useState<VenueFilterOption[]>([]);
  const [searchString, setSearchString] = useState<string>('');

  const getVenues = (
    reqParams: VenuesRequestParams,
  ): Promise<VenueFilterListingResponse> =>
    postRequest({
      path: `api/admin/venue/filter-list`,
      data: reqParams,
    }).then((res) => res.data);

  const { fetchNextPage, isFetching, isLoading, hasNextPage, data } =
    useInfiniteQuery(
      [QUERY_KEY.GET_LIST_VENUE_FILTER, searchString],
      ({ pageParam = 0 }) =>
        getVenues({
          page: pageParam,
          size: 10,
          search: searchString,
        }),
      {
        getNextPageParam: (_lastPage, allPages) =>
          getNextPage(_lastPage, allPages, 10),
      },
    );

  useEffect(() => {
    const totalData = data?.pages.flatMap((page) =>
      page.data.map((d) => ({
        id: d.id,
        name: d.locationName,
        addressLine1: d.addressLine1,
      })),
    );
    setItems(totalData || []);
  }, [data?.pages]);

  const onSearch = (search: string) => {
    setSearchString(search);
  };

  return {
    items,
    fetchNextPage,
    isFetching,
    isLoading,
    hasNextPage,
    onSearch,
  };
};
